import React, { useEffect, useState } from 'react';
import { BiStopwatch } from 'react-icons/bi';
import { FiMousePointer } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../../store/languageSlice';
import { hhcBookSerivce } from '../../../utilFunctions/homwHealthCare';
import Loader from '../../UI/Loader';

import './style.css';

const RightSidebar = ({
  selectedIds,
  subQuestionErrors,
  resetSelection
}) => {
  const { t, isRtl } = useSelector(selectLanguage);

  const [name, setName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [email, setEmail] = useState('');

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [error, setError] = useState(false);

  const [validationErrors, setValidationErrors] = useState({
    name: '',
    phoneNo: '',
  });

  const subQuestionErrorList = Object.values(
    subQuestionErrors || {}
  );

  useEffect(() => {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : null;

    if (userInfo) {
      setName(userInfo?.firstName || '');
      setPhoneNo(userInfo?.mobileNumber || '');
      setEmail(userInfo?.email || '');
    }
  }, []);

  const handleBookService = async () => {
    setMessage();
    setError(false);

    if (
      !selectedIds?.length ||
      subQuestionErrorList.length > 0
    ) {
      return;
    }

    const errors = {
      name: '',
      phoneNo: '',
    };

    if (!name.trim()) {
      errors.name = t.NameRequired || 'Name is required';
    }

    if (!phoneNo.trim()) {
      errors.phoneNo = t.PhoneNumberRequired || 'Phone number is required';
    }

    setValidationErrors(errors);

    if (errors.name || errors.phoneNo) {
      return;
    }

    setLoading(true);

    try {
      const responseData = await hhcBookSerivce({
        questionIds: selectedIds,
        submittedFor: name.trim(),
        contact: '+966' + phoneNo.trim(),
        email: email.trim(),
      });

      console.log("responseData", responseData)

      if (responseData === 200) {
        setMessage(t.HhsSuccess);
        resetSelection();
      } else {
        setError(true);
        setMessage(t.HhsFailed);
      }
    } catch (err) {
      setError(true);
      setMessage(t.HhsFailed);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(message){
      setTimeout(()=>setMessage(), 3000)
    }
  },[message])

  const showButton =
  selectedIds?.length > 0 &&
  subQuestionErrorList.length === 0;

  return (
    <div className="card">
      <div className="media-obj">
        <span>
          <BiStopwatch />
        </span>

        <div className="info">
          <h4>{t.SwiftCallback}</h4>
          <p>{t.SwiftCallbackMessage}</p>
        </div>
      </div>

      <div className="media-obj mt-8">
        <span>
          <FiMousePointer />
        </span>

        <div className="info">
          <h4>{t.InstantHomeHealthcare}</h4>
          <p>{t.InstantHomeHealthcareMsg}</p>
        </div>
      </div>

      <form id="book-service">
        {!message && (
        <>
        <label htmlFor="name">
          {t.Name}*
          <br />

          <input
            type="text"
            id="name"
            value={name}
            placeholder={t.EnterYourFirstName}
            onChange={(e) => {
              setName(e.target.value);

              if (validationErrors.name) {
                setValidationErrors((prev) => ({
                  ...prev,
                  name: '',
                }));
              }
            }}
          />

          {validationErrors.name && (
            <p className="text-tertiary mt-1">
              {isRtl ? "الاسم مطلوب" : "Name is required" }
            </p>
          )}
        </label>

        <label htmlFor="phoneNo">
          {t.CellPhoneNumber}*
          <br />

          <div className="countrycode" dir="ltr">
            <div className="code text-secondary">(+966)</div>

            <input
              id="phoneNo"
              type="number"
              value={phoneNo}
              placeholder="5xxxxxxxx"
              className='noArrow'
              onChange={(e) => {
                setPhoneNo(e.target.value);

                if (validationErrors.phoneNo) {
                  setValidationErrors((prev) => ({
                    ...prev,
                    phoneNo: '',
                  }));
                }
              }}
            />
          </div>

          {validationErrors.phoneNo && (
            <p className="text-tertiary mt-1">
              {t.MobileNumberRequired}
            </p>
          )}
        </label>

        <label htmlFor="email">
          {t.Email}
          <br />

          <input
            id="email"
            type="email"
            value={email}
            placeholder={t.EnterYourEmailAddress}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        {subQuestionErrorList.length > 0 && (
          <div className="my-2">
            {subQuestionErrorList.map((item) => (
              <p
                key={item.questionNumber}
                className="text-tertiary mt-1"
              >
                {isRtl
                  ? `يرجى اختيار خيار فرعي واحد على الأقل من السؤال ${item.questionNumber}`
                  : `Please select at least one sub-question from question ${item.questionNumber}.`}
              </p>
            ))}
          </div>
        )}

        <button
          type="button"
          onClick={handleBookService}
          disabled={!showButton}
          style={{ opacity: showButton ? 1 : 0.5 }}
        >
          {loading ? (
            <Loader size="small" roundLoader />
          ) : (
            t.BookService
          )}
        </button>
        </>)}

        {message && (
          <p className={`${error ? 'errorMsg' : 'successMsg'} my-4 text-center`}>
            <span>{message}</span>
          </p>
        )}
      </form>
    </div>
  );
};

export default RightSidebar;